import {
  Paragraph,
  SectionType,
  TextRun,
  TabStopType,
  TabStopPosition,
  Tab,
  HeadingLevel,
  ISectionOptions,
} from 'docx'
import formatDate from '../common/date'
import { Resume } from '@/types/resume/v1'

const awards = ({ awards }: Resume.Schema): ISectionOptions => {
  return {
    properties: {
      type: SectionType.CONTINUOUS,
    },
    children: [
      new Paragraph({
        text: '\n',
      }),
      new Paragraph({
        text: 'Awards',
        heading: HeadingLevel.HEADING_2,
      }),
      ...awards.reduce<Paragraph[]>((acc, award) => {
        return [...acc, ...createAwardItem(award)]
      }, []),
    ],
  }
}

const createAwardItem = (award: Resume.Award): Paragraph[] => {
  const item: Paragraph[] = []
  item.push(
    new Paragraph({
      text: '\n',
    })
  )
  item.push(
    new Paragraph({
      children: [
        new TextRun({
          text: award.title,
          bold: true,
        }),
        new TextRun({
          children: [new Tab()],
        }),
        new TextRun({
          text: formatDate(award.date),
        }),
      ],
      tabStops: [
        {
          type: TabStopType.RIGHT,
          position: TabStopPosition.MAX,
        },
      ],
    })
  )
  item.push(
    new Paragraph({
      text: award.awarder,
    })
  )
  if (award.summary) {
    item.push(
      new Paragraph({
        text: '\n',
      })
    )
    item.push(
      new Paragraph({
        text: award.summary,
      })
    )
  }
  return item
}

export default awards
